import {default_position, default_params} from './state';

/**
 * Establecer un valor para la variable positions.
 */
export function setPositions(state, positions) {
    state.positions = positions;
}

/**
 * Establecer un valor para la variable position.
 */
export function setPosition(state, position) {

    position.epps = [];
    position.exams = [];

    position.wor_position_epps.map((epp) => {
        position.epps.push(epp.form_submission_id);
    });

    position.wor_position_exams.map((exam) => {
        position.exams.push(exam.sys_list_exam_id);
    });

    state.position = position;
}

/**
 * Establecer un valor para el atributo code de la variable position.
 */
export function setCodeToPosition(state, code) {
    state.position.code = code;
}

/**
 * Establecer un valor para la variable editing.
 */
export function setEditing(state, editing) {
    state.editing = editing;
}

/**
 * Establecer un valor para la variable companies.
 */
export function setCompanies(state, companies) {
    state.companies = companies;
}

/**
 * Establecer el valor por defecto de params.
 */
export function resetParams(state) {
    state.params = default_params();
    state.positions = {data: []};
}

/**
 * Establecer el valor por defecto de position.
 */
export function resetPosition(state) {
    state.position = default_position();
}

/**
 * Establecer un valor para el atributo show la variable modal.
 */
export function setModalShow(state, show) {
    state.modal.show = show;
}

/**
 * Restablecer el valor del atributo page de la variable params.
 */
export function resetPageParams(state) {
    state.params.page = 1;
}

/**
 * Establecer un valor para la variable areas.
 */
export function setAreas(state, areas) {
    state.areas = areas;
}

/**
 * Establecer un valor para la variable epps.
 */
export function setEpps(state, epps) {
    state.epps = epps;
}

/**
 * Establecer un valor para la variable exams.
 */
export function setExams(state, exams) {
    state.exams = exams;
}

/**
 * Establecer un valor para el atributo show de la variable modal_upload.
 */
export function setShowToModalUpload(state, show) {
    state.upload = {file: null};
    state.modal_upload.show = show;
}

